import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApplicationBanks,
  IApplications,
  StatusObj,
} from "../authSliceLogin/authSliceLogin";
// import { API_CENTER } from "../../../services/api/api";
import { message } from "antd";
import { API_CENTER } from "../../../services/api/api";

interface IApplicationsState {
  applications: IApplications[];
  typeBG: {
    id: number;
    name: string;
  }[];
  startIndex: number;
  last_page: number;
  scrollPosition: number;
  filter: IFilterApplications;
}
interface ResponseAction {
  data: IApplications[];
  last_page: number;
}

interface IChangeStatus {
  id: number;
  status: StatusObj;
}

export interface IFilterApplications {
  bg_type_id: number | null;
  bank_id: number | null;
  created_at: string | null;
  organization_inn: string | null;
  status: string | null;
  application_id: number | null;
}

const initialState: IApplicationsState = {
  applications: {} as IApplications[],
  typeBG: [
    {
      id: 0,
      name: "string",
    },
  ],
  startIndex: 0,
  last_page: 0,
  scrollPosition: 0,
  filter: {
    bg_type_id: null,
    bank_id: null,
    created_at: null,
    organization_inn: null,
    status: "",
    application_id: null,
  },
};

const API = new API_CENTER();
export const API_APPLICATIONS_ALL_SLICES_FILTER = createAsyncThunk<
  IApplications[],
  {
    bg_type_id: number | null;
    bank_id: number | null;
    created_at: string | null;
  },
  {
    rejectValue: string;
  }
>(
  "applicationsAllSlice/API_APPLICATIONS_ALL_SLICES_FILTER",
  async (value, { rejectWithValue }) => {
    let url = "applications?";
    if (value.bg_type_id !== null) {
      url += `bg_type_id=${value.bg_type_id}&`;
    }
    if (value.created_at !== null) {
      url += `created_at=${value.created_at}&`;
    }
    if (value.bank_id !== null) {
      url += `bank_id=${value.bank_id}&`;
    }
    // Remove the trailing '&' from the URL
    url = url.slice(0, -1);
    const response = await API.GET_API(url, "GET");
    if (response.success) {
      return response.data.applications.data;
    } else {
      return rejectWithValue(response.message);
    }
  }
);

export const API_APPLICATION_ALL_SLICES_LOAD_MORE = createAsyncThunk<
  { data: IApplications[]; last_index: number },
  number,
  {
    rejectValue: string;
  }
>(
  "applicationsAllSlice/API_APPLICATION_ALL_SLICES_LOAD_MORE",
  async (value, { rejectWithValue }) => {
    const response = await API.GET_API(`applications?page=${value}`);
    if (response.success) {
      return {
        data: response.data.applications.data,
        last_index: response.data.applications.last_index,
      };
    } else {
      return rejectWithValue(response.message);
    }
  }
);

export const API_APPLICATION_ALL_SLICES_REFRESH = createAsyncThunk<
  { data: IApplications[]; last_index: number },
  number,
  {
    rejectValue: string;
  }
>(
  "applicationsAllSlice/API_APPLICATION_ALL_SLICES_REFRESH",
  async (value, { rejectWithValue }) => {
    const response = await API.GET_API(`applications?page=${value}`);
    if (response.success) {
      return {
        data: response.data.applications.data,
        last_index: response.data.applications.last_index,
      };
    } else {
      return rejectWithValue(response.message);
    }
  }
);

// список заявок
const applicationsAllSlice = createSlice({
  name: "APPLICATIONS_ALL_SLICES",
  initialState: initialState,
  reducers: {
    // обновить все заявки
    UP_DATE_APPLICATIONS_ALL: (
      state,
      actions: PayloadAction<ResponseAction, string>
    ) => {
      state.applications = actions.payload.data.map((item) => ({
        ...item,
        isNewMessage: false,
      }));
      state.last_page = actions.payload.last_page;
    },
    // добавление новой заявки
    ADD_NEW_APPLICATION: (
      state,
      actions: PayloadAction<IApplications, string>
    ) => {
      state.applications.unshift(actions.payload);
    },
    // обновить статус заявки
    UP_DATE_APPLICATION_STATUS: (
      state,
      actions: PayloadAction<IChangeStatus, string>
    ) => {
      state.applications = state.applications.map((item: IApplications) => {
        if (item.id === actions.payload.id) {
          return { ...item, status: actions.payload.status };
        }
        return item;
      });
    },
    // добавление заявок с других страниц при нажатии кнопки загрузить ещё
    UP_DATE_APPLICATIONS_WITH_PAGE: (
      state,
      actions: PayloadAction<ResponseAction, string>
    ) => {
      if (actions.payload.data && Array.isArray(actions.payload.data)) {
        state.applications.push(...actions.payload.data);
        // state.startIndex += 50;
      } else {
        message.error("Ошибка сервера");
      }
    },
    // обновить тип бг
    UP_DATE_APPLICATIONS_TYPE_BG: (
      state,
      actions: PayloadAction<
        {
          id: number;
          name: string;
        }[],
        string
      >
    ) => {
      state.typeBG = actions.payload;
    },
    UP_DATE_APPLICATIONS_SCROLL: (
      state,
      actions: PayloadAction<number, string>
    ) => {
      state.scrollPosition = actions.payload;
    },
    UP_DATE_APPLICATIONS_START_INDEX: (
      state,
      actions: PayloadAction<number, string>
    ) => {
      state.startIndex = actions.payload;
    },
    // отображение на заявке уведомления о новом сообщении в чате
    UP_DATE_IS_NEW_MESSAGE: (
      state,
      actions: PayloadAction<{ id: number; isNewMessage: boolean }>
    ) => {
      if (Array.isArray(state.applications)) {
        state.applications = state.applications.map((item: IApplications) => {
          if (item.id === actions.payload.id) {
            return {
              ...item,
              isNewMessage: actions.payload.isNewMessage,
            };
          } else {
            return item;
          }
        });
      }
    },
    // пометка заявки как прочитанная
    UP_DATE_IS_READ: (
      state,
      actions: PayloadAction<{ id: number; read: boolean }>
    ) => {
      if (Array.isArray(state.applications)) {
        state.applications = state.applications.map((item: IApplications) => {
          if (item.id === actions.payload.id) {
            return {
              ...item,
              read: actions.payload.read,
            };
          } else {
            return item;
          }
        });
      }
    },
    // добавление банка к заявке
    ADD_NEW_BANK: (
      state,
      actions: PayloadAction<{ banks: ApplicationBanks[]; id: number }>
    ) => {
      state.applications = state.applications.map((item: IApplications) => {
        if (item.id === actions.payload.id) {
          return { ...item, application_banks: actions.payload.banks };
        }
        return item;
      });
    },
    // обновить значения фильтра для сохранения выбранных значений
    UP_DATE_FILTER: (state, actions: PayloadAction<IFilterApplications>) => {
      state.filter = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      API_APPLICATIONS_ALL_SLICES_FILTER.fulfilled,
      (state, action) => {
        state.applications = action.payload;
      }
    );
    builder.addCase(
      API_APPLICATIONS_ALL_SLICES_FILTER.rejected,
      (state, actions) => {
        const errorMessage = actions.error.message;
        message.error(errorMessage);
      }
    );
    builder.addCase(
      API_APPLICATION_ALL_SLICES_LOAD_MORE.fulfilled,
      (state, action) => {
        if (action.payload.data && Array.isArray(action.payload.data)) {
          state.applications.push(...action.payload.data);
          state.startIndex += 50;
        } else {
          message.error("Ошибка сервера");
        }
      }
    );
    builder.addCase(
      API_APPLICATION_ALL_SLICES_LOAD_MORE.rejected,
      (state, actions) => {
        const errorMessage = actions.error.message;
        message.error(errorMessage);
      }
    );
    builder.addCase(
      API_APPLICATION_ALL_SLICES_REFRESH.fulfilled,
      (state, action) => {
        if (action.payload.data && Array.isArray(action.payload.data)) {
          state.applications = action.payload.data;
          state.startIndex = 0;
          // state.scrollPosition = 0;
        } else {
          message.error("Ошибка сервера");
        }
      }
    );
    builder.addCase(
      API_APPLICATION_ALL_SLICES_REFRESH.rejected,
      (state, actions) => {
        const errorMessage = actions.error.message;
        message.error(errorMessage);
      }
    );
  },
});

// export const selectProfile = (state: RootState) => state.;
export const {
  UP_DATE_APPLICATIONS_ALL,
  UP_DATE_APPLICATIONS_TYPE_BG,
  UP_DATE_APPLICATIONS_WITH_PAGE,
  UP_DATE_IS_NEW_MESSAGE,
  UP_DATE_IS_READ,
  UP_DATE_APPLICATION_STATUS,
  ADD_NEW_APPLICATION,
  ADD_NEW_BANK,
  UP_DATE_FILTER,
  UP_DATE_APPLICATIONS_START_INDEX,
} = applicationsAllSlice.actions;

export default applicationsAllSlice.reducer;
